var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"workbench-tab"},_vm._l((_vm.workbenchTabList),function(item){return _c('div',{key:item.value,staticClass:"tab-item",class:{ active: item.value === _vm.innerWorkbenchTab },on:{"click":function($event){return _vm.changeTabType(item.value)}}},[_vm._v(" "+_vm._s(item.label)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }